export default __webpack_public_path__ + "static/media/cleaners.48493126.jpeg";